(() => {
  if (window.__awPageSeriesWhitecoatLoaded) {
    return;
  }

  window.__awPageSeriesWhitecoatLoaded = true;

  const instances = new Map();
  const selectors = {
    root: "[data-aw-page-series-whitecoat]",
    scroll: "[data-aw-page-series-whitecoat-scroll]",
    scrollbar: "[data-aw-page-series-whitecoat-scrollbar]",
    thumb: "[data-aw-page-series-whitecoat-scrollbar-thumb]",
    wrapper: ".rte__table-wrapper",
  };

  class AWPageSeriesWhitecoat {
    constructor(root) {
      this.root = root;
      this.scroll = root.querySelector(selectors.scroll);
      this.scrollbar = root.querySelector(selectors.scrollbar);
      this.thumb = root.querySelector(selectors.thumb);
      this.viewport = null;
      this.rafId = null;
      this.resizeObserver = null;
      this.mutationObserver = null;

      this.onScroll = this.requestUpdate.bind(this);
      this.onResize = this.update.bind(this);
      this.onMutate = this.handleMutations.bind(this);

      if (!this.scroll || !this.scrollbar || !this.thumb) {
        return;
      }

      this.refreshViewport();
      this.bindEvents();
      this.update();
    }

    getViewport() {
      return this.scroll.querySelector(selectors.wrapper) || this.scroll;
    }

    refreshViewport() {
      const nextViewport = this.getViewport();

      if (nextViewport === this.viewport) {
        return;
      }

      if (this.viewport) {
        this.viewport.removeEventListener("scroll", this.onScroll);
      }

      this.viewport = nextViewport;

      if (this.viewport) {
        this.viewport.addEventListener("scroll", this.onScroll, { passive: true });
      }

      if (this.resizeObserver && this.viewport) {
        this.resizeObserver.observe(this.viewport);
      }
    }

    bindEvents() {
      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.root);
        this.resizeObserver.observe(this.scroll);
        if (this.viewport) {
          this.resizeObserver.observe(this.viewport);
        }

        const table = this.scroll.querySelector("table");
        if (table) {
          this.resizeObserver.observe(table);
        }
      } else {
        window.addEventListener("resize", this.onResize);
      }

      this.mutationObserver = new MutationObserver(this.onMutate);
      this.mutationObserver.observe(this.scroll, {
        childList: true,
        subtree: true,
      });
    }

    handleMutations() {
      this.refreshViewport();
      this.requestUpdate();
    }

    requestUpdate() {
      if (this.rafId) {
        return;
      }

      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.update();
      });
    }

    update() {
      this.refreshViewport();

      const viewport = this.viewport || this.scroll;
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const canScroll = maxScroll > 1;

      this.scrollbar.classList.toggle("is-hidden", !canScroll);

      if (!canScroll) {
        this.thumb.style.width = "0";
        this.thumb.style.transform = "translateX(0)";
        return;
      }

      const trackWidth = this.scrollbar.clientWidth;
      const thumbWidth = Math.max(24, trackWidth * (viewport.clientWidth / viewport.scrollWidth));
      const maxThumbOffset = Math.max(0, trackWidth - thumbWidth);
      const progress = Math.min(Math.max(viewport.scrollLeft / maxScroll, 0), 1);
      const thumbOffset = maxThumbOffset * progress;

      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${thumbOffset}px)`;
    }

    destroy() {
      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      if (this.scroll) {
        this.scroll.removeEventListener("scroll", this.onScroll);
      }

      if (this.viewport) {
        this.viewport.removeEventListener("scroll", this.onScroll);
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      } else {
        window.removeEventListener("resize", this.onResize);
      }

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
    }
  }

  function initAll(container = document) {
    container.querySelectorAll(selectors.root).forEach((root) => {
      if (instances.has(root)) {
        instances.get(root).update();
        return;
      }

      instances.set(root, new AWPageSeriesWhitecoat(root));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
